<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <faq-form :id="id" />
        </b-card>
    </div>
</template>


<script>
    import FaqForm from '~/components/forms/admin/faq/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
        },
        components: {
            'faq-form': FaqForm,
        },
    }
</script>

<style lang="css" scoped>
</style>